import { ReactNode } from 'react';

import classNames from 'classnames';

import { ProjectContentTableOfContentTab } from '../types';
import { ItemsProps } from '../types';
import { howToParticipate, importantInformation, keyFeatures, vestingTerms } from './constants';

export type SubTitleProps = {
  children: ReactNode;
  className?: string;
  index?: number;
};

export type ListProps = {
  items: Array<ItemsProps>;
  description?: string;
  className?: string;
};

const Info = ({ children, className, index }: SubTitleProps) => (
  <div
    className={classNames(
      'flex items-start justify-start p-6 border border-primary-200 text-base lg:text-2xl rounded-lg font-normal',
      className,
    )}
  >
    <span className="flex justify-center items-center mr-3 p-4 rounded-full w-6 h-6 bg-image-gradient font-semibold text-neutral-50">
      {index}
    </span>
    {children}
  </div>
);

const List = ({ items, description, className }: ListProps) => {
  return (
    <>
      {description && <p className="text-lg font-semibold text-neutral-600">{description}</p>}
      <ul className={classNames('list-disc pl-6', className)}>
        {items.map(({ id, content, item }) => {
          if (Array.isArray(item)) {
            return (
              <li key={id} className="font-normal">
                {content}
                <ul className="list-disc pl-6">
                  {item.map(({ id: subId, subItem }) => (
                    <li key={subId}>{subItem}</li>
                  ))}
                </ul>
              </li>
            );
          } else {
            return <li key={id}>{item}</li>;
          }
        })}
      </ul>
    </>
  );
};

export const tableOfContentTab: ProjectContentTableOfContentTab['content'] = [
  {
    id: 'overview',
    title: 'Overview',
    content: (
      <>
        <p className="font-semibold">
          Welcome to the "Magic Launchpad SQR Token Sale Test Run"! This is an exclusive opportunity
          for the Magic Square Community to test out all the features of our launchpad. Participants
          will be able to try out different functions and purchase SQR tokens at a discounted price.
          The price of SQR during the token sale will be set on the start day and will remain fixed
          throughout the sale period.
        </p>
      </>
    ),
  },
  {
    id: 'key-features',
    title: 'Key Features of the Test Run',
    content: <List items={keyFeatures} />,
  },
  {
    id: 'vesting-terms',
    title: 'Vesting Terms',
    content: <List items={vestingTerms} />,
  },
  {
    id: 'how-to-participate',
    title: 'How to Participate',
    content: (
      <section className="flex flex-col gap-6">
        <Info index={1}>
          <span className="pt-1 lg:pt-0 font-semibold">Connect Wallet and Pass KYC</span>
        </Info>
        <Info index={2}>
          <div className="pt-1 lg:pt-0">
            <span className="font-semibold">Token sale Types:</span>
            <List items={howToParticipate} />
          </div>
        </Info>
        <Info index={3}>
          <div className="pt-1 lg:pt-0">
            <span className="font-semibold">Contribute: </span> Deposit your funds into the chosen
            pool
          </div>
        </Info>
        <Info index={4}>
          <div className="pt-1 lg:pt-0">
            <span className="font-semibold">Claim Tokens: </span> Once the sale ends, claim 25% of
            your purchased SQR tokens once the token sale ends. The remaining tokens will be subject
            to the vesting schedule
          </div>
        </Info>
        <Info index={5}>
          <div className="pt-1 lg:pt-0">
            <span className="font-semibold">Sell OTC: </span> The tokens that are locked for 30 days
            and have a 3-month linear vesting can be sold on the recently released OTC Platform. Any
            tokens you do not sell will be automatically airdropped to you
          </div>
        </Info>
      </section>
    ),
  },
  {
    id: 'important-information',
    title: 'Important Information',
    content: <List items={importantInformation} />,
  },
];
